import { UserRestriction as UserRestrictionComponent } from './UserRestiction.component';
import { connector } from './UserRestiction.connector';
export const UserRestriction = connector(UserRestrictionComponent);
